import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {GetComponentProps} from '../../utils/utility-types';

import StarsIcon from '../../assets/icons/stars.svg';
import {Badge} from '../../uikit/Badge';
import {Icon} from '../../uikit/Icon';

type Props = {
  iconOnly?: boolean;
  variant?: GetComponentProps<typeof Badge>['variant'];
};

export const AutoGeneratedBadge: FC<Props> = ({iconOnly, variant}) => {
  const {t} = useI18n();

  if (iconOnly) {
    return <Icon color="icon.gray" size={20} svg={StarsIcon} />;
  }

  return (
    <Badge
      icon={StarsIcon}
      title={t('shared:auto_generated')}
      variant={variant}
    />
  );
};
